<template>
  <div class="flex flex-col p-6">
    <i class="icon-comment text-32 leading-8 text-accent-yellow mb-5" />
    <h2 class="text-grayscale-96 font-bold leading-130 mb-3">
      Feedback on your track/demo
    </h2>

    <p
      :class="[
        isFullyBooked ? 'mb-3' : 'mb-[86px]',
        'text-13 text-grayscale-90 leading-140 font-medium',
      ]"
    >
      Ask your questions and receive a written, audio or video message within 7
      days.
    </p>
    <div
      v-if="isFullyBooked"
      class="flex items-center gap-2 text-helpers-validation mb-8"
    >
      <i class="icon-info text-16 leading-4" />
      <p class="text-13 leading-140 font-bold">Fully Booked</p>
    </div>
    <div class="flex-1 items-end flex justify-between">
      <p>
        <span class="font-bold text-2xl leading-100 text-grayscale-96"
          >${{ price }}</span
        >
        <span class="ml-1.5 text-grayscale-80 leading-100">/ Track</span>
      </p>
      <general-button v-if="!isFullyBooked" height="small" @click="request"
        ><span class="whitespace-nowrap">Book now</span></general-button
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import type { User } from "@/types/user";
import { computed } from "vue";
import type { PropType } from "vue";
import GeneralButton from "@/components/layout/buttons/GeneralButton.vue";

const props = defineProps({
  pro: {
    type: Object as PropType<User>,
    required: true,
  },
  price: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(["request"]);

const isFullyBooked = computed(
  () => (props.pro.feedBackCount ?? 0) >= (props.pro.feedBacksPerWeek ?? 0),
);

const request = () => {
  emit("request");
};
</script>
